import UpgradeCta from './UpgradeCta';

export default UpgradeCta;
